import styled from 'styled-components';
import { Column } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const LeaderBiography = styled('div')`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
`;

export const KeyMetricWrapper = styled(Column)`
  ${media.smDown`
    &:first-child{
      margin-bottom: ${({ theme }) => theme.x3spacePx}px;
    }
  `}
`;

export const NoCEO = styled('p')`
  margin: 0;
`;

export const Capper = styled('span')`
  text-transform: capitalize;
`;
